<!--

    DEPRECATED COMPONENT

-->
<template>
    <div>
        <div class="mb-6 -mt-4">
            <h1>ID Document Upload</h1>
        </div>

        <ValidationObserver ref="proofOfIdentityDocumentObserver">
            <div class="mb-6">
                <p>Please upload an image of a valid document that supports your identity.</p>
                <p>
                    All copies must be clear and not obfuscated and must be in date (valid) and show an expiry date. If
                    the copy does not meet these requirements further copies may be requested. We accept copies of
                    Passport, Driving License or National Identity card.
                </p>
            </div>

            <div class="upload-guide mb-6">
                <div class="flex items-center mb-4">
                    <div class="mr-4 shrink-0">
                        <img width="30" height="30" :src="global.app.url + 'images/icons/upload-guide-focussed.svg'" />
                    </div>
                    <div>Make sure your document fills up most of the image. 80% is ideal.</div>
                </div>
                <div class="flex items-center mb-4">
                    <div class="mr-4 shrink-0">
                        <img width="30" height="30" :src="global.app.url + 'images/icons/upload-guide-plain.svg'" />
                    </div>
                    <div>The document needs to be on a plain background.</div>
                </div>
                <div class="flex items-center mb-4">
                    <div class="mr-4 shrink-0">
                        <img width="30" height="30" :src="global.app.url + 'images/icons/upload-guide-light.svg'" />
                    </div>
                    <div>
                        Avoid any glare or light reflection as the text needs to be clear, sharp and visible in the
                        image.
                    </div>
                </div>
                <div class="flex items-center mb-4">
                    <div class="mr-4"><img width="30" height="30" :src="global.app.url + 'images/icons/upload-guide-centered.svg'" /></div>
                    <div>The ID needs to be clean and face image clearly visible.</div>
                </div>
                <div class="flex items-center">
                    <div class="mr-4 shrink-0">
                        <img width="30" height="30" :src="global.app.url + 'images/icons/upload-guide-plain.svg'" />
                    </div>
                    <div>
                        ID document must be high resolution, JPEG or PNG format, and colour. File size must not exceed
                        8MB.
                    </div>
                </div>
            </div>
            <div class="mb-6" v-if="hasIdDocumentError">
                <AlertComponent :message="'There was a problem processing your ID. Reason: ' + global.submission_errors.isIdDocumentError" />
            </div>

            <div class="mb-6">
                <FileUploadComponent
                    id="poi-document"
                    name="poi_document"
                    label="Upload an image"
                    :apiEndpointUrl="'/user/' + this.user.id + '/poi/document'"
                    :fileData="proofOfIdentityDocument"
                />
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { ValidationObserver } from "vee-validate";
import stepperValidationService from "@services/stepperValidationService";

export default {
    name: "POIDocumentFormComponent",
    props: {},
    components: {
        ValidationObserver,
    },
    props: {
        step: { default: "" },
    },
    computed: {
        ...mapGetters(["user", "proofOfIdentityDocumentState", "global"]),
        proofOfIdentityDocument: {
            get() {
                return this.proofOfIdentityDocumentState;
            },
            set(value) {
                return value;
            },
        },
        alertMessage() {
            let reason =
                this.global.submission_errors != undefined ? this.global.submission_errors.isIdDocumentError : "";
            return (
                "There was a problem processing your ID. Reason: " +
                reason +
                '. Please <a class="text-white" href="https://optionsdesk.com/id-picture-requirements/" target="_blank" rel="noopener">read our ID Picture Requirements</a> for more info.'
            );
        },
    },
    data() {
        return {
            isFormValidated: false,
            hasIdDocumentError: false,
        };
    },
    methods: {
        ...mapActions(["doGetProofOfIdentityDocument"]),
        doValidateForm() {
            console.log("doValidateForm");
            stepperValidationService.checkStepperStepStatus(
                this.step,
                this.proofOfIdentity,
                this.$refs.proofOfIdentityDocumentObserver,
                false,
                true
            );
        },
    },
    mounted() {
        this.$root.$on("submittingApplication", () => this.doValidateForm());
        this.$root.$on("stepChanged", (step) => {
            if (this.step < step && !this.isFormValidated) {
                this.doValidateForm();
                this.isFormValidated = true;
                this.hasIdDocumentError = false;
            } else if (this.step == step) {
                this.isFormValidated = false;
            }
        });
        this.$root.$on("isIdDocumentError", () => (this.hasIdDocumentError = true));

        this.doGetProofOfIdentityDocument();
    },
    watch: {
        "proofOfIdentity.file_url"() {
            stepperValidationService.checkStepperStepStatus(
                this.step,
                this.proofOfIdentity,
                this.$refs.proofOfIdentityDocumentObserver
            );
        },
    },
};
</script>
